import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import { Link } from '@bd/bdcore-named-routes';
import { SanitizeHtml, buildThumbnailUrl } from '@bd/bdcore-utilities';
import { css } from '@bd/bdui-styles/emotion';
import { colors, typography } from '../../../styles';

const styles = css`
  .TestimonialBanner {
    position: relative;
    &::after {
      content: '';
      position: absolute;
      z-index: 1;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      background-color: ${colors.black};
      opacity: .7;
    }
    @media (min-width: 992px) {
      background-position: center center;
      background-size: cover;
    }
  }
  .TestimonialBanner_media {
    position: relative;
    height: 260px;
    overflow: hidden;
    background-size: cover;
    background-position: center center;
    margin: 0 0 30px 0;
    margin: 0 10px;
    z-index: 2;
    @media (min-width: 992px) {
      height: 100%;
      min-height: 300px;
      margin: 0;
      padding: 0;
      text-align:left;
    }
  }
  .TestimonialBanner_content {
    padding: 45px 30px;
    position: relative;
    z-index: 2;
    text-align:center;
    @media (min-width: 992px) {
      padding: 180px 100px 180px 45px;
      text-align:left;
    }
  }
  .TestimonialBanner_graphic {
    display: none;
    @media (min-width: 992px) {
      position: absolute;
      display: block;
      width: 170px;
      height: 170px;
      border-radius: 50%;
      overflow: hidden;
      background-image: url('/images/icon-quotes-white.svg');
      background-position: center center;
      background-repeat: no-repeat;
      top: calc(50% - 85px);
      right: -115px;
      &::after {
        content: '';
        position: absolute;
        z-index: -1;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        background-color: ${colors.brand4};
        opacity: .85;
      }
    }
  }
  .TestimonialBanner_headline {
    font-size: 36px;
    font-family: ${typography.Serif};
    line-height: .7;
    color: ${colors.white};
    @media (min-width: 480px) {
      font-size: 48px;
    }
    @media (min-width: 992px) {
      font-size: 67px;
    }
    &::after {
      content: '';
      display: block;
      position: relative;
      width: 75px;
      height: 4px;
      margin: 30px auto;
      background-color: ${colors.brand4};
      @media (min-width: 992px) {
        margin: 30px 0;
      }
    }
  }
  .TestimonialBanner_subheadline {
    font-weight: normal;
    display: block;
    font-size: 24px;
    line-height:30px;
    color: ${colors.white};
    margin: 10px 0;
    @media (min-width: 480px) {
      font-size: 36px;
      line-height:42px;
      margin: 15px 0;
    }
    @media (min-width: 992px) {
      font-size: 48px;
      line-height:54px;
      margin: 20px 0;
    }
  }
  .TestimonialBanner_body, .TestimonialBanner_body p {
    font-size: 21px;
    line-height: 1.5;
    font-weight: 300;
    font-family: ${typography.Condensed};
    color: ${colors.white};
    margin: 0 10px 30px 10px;
    @media (min-width: 992px) {
      font-size: 27px;
      margin: 0 0 30px 0;
    }
  }
`;

function TestimonialBanner({ content }) {
  return (
    <div className={styles}>
      <div className="TestimonialBanner" style={{ backgroundImage: `url(${buildThumbnailUrl(get(content, '[0].background_image.contentUrl'), { width: 2000, height: 2000 })})` }}>
        <div className="container">
          <div className="row">
            <div className="col-lg-5 ml-lg-auto order-lg-2">
              <div className="TestimonialBanner_media" style={{ backgroundImage: `url(${buildThumbnailUrl(get(content, '[0].image.contentUrl'), { width: 1200, height: 1200 })})` }} />
            </div>
            <div className="col-lg-7 order-lg-1">
              <div className="TestimonialBanner_content">
                <h2 className="TestimonialBanner_headline">
                  {get(content, '[0].headline')}&nbsp;<br />
                  <span className="TestimonialBanner_subheadline">{get(content, '[0].subheadline')}</span>
                </h2>
                <div className="TestimonialBanner_body" dangerouslySetInnerHTML={SanitizeHtml(get(content, '[0].body'))} />
                <Link name="testimonials" className="btn">{get(content, '[0].button_text')}</Link>
                <div className="TestimonialBanner_graphic" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

TestimonialBanner.propTypes = {
  content: PropTypes.arrayOf(PropTypes.object).isRequired,
};

TestimonialBanner.defaultProps = {
};

export default TestimonialBanner;



// WEBPACK FOOTER //
// ./src/components/PageLoader/Sections/TestimonialBanner.section.js